function DevToolingMount() {
  return null;
}

module.exports = { DevToolingMount };
